import { Link } from "react-router-dom";

export default function CTABanner() {
  return (
    <section className="py-5 bg-light border-top" aria-labelledby="cta-banner-title">
      <div className="container text-center">
        <div className="mx-auto" style={{ maxWidth: '720px' }}>
          <h2 className="display-5 fw-bold text-dark mb-3" id="cta-banner-title">Ready for your Gawkari Experience?</h2>
          <p className="lead text-secondary mb-4">
            From sunrise agro-trails to twilight campfires, design a nature-forward itinerary tailored to your pace.
            Start planning your perfect Maharashtrian countryside escape today.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <Link className="btn btn-primary px-4 py-2" to="/enquiry">
              Book Your Stay
            </Link>
            <Link className="btn btn-outline-secondary px-4 py-2" to="/gallery">
              View Gallery
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
